import React, { lazy } from 'react';

const CurrencySetupListing = lazy(() =>
  import(
    '@contract-root/admin-react/src/containers/SystemAdminModule/CurrencySetupModule/CurrencySetupListing'
  ).then(module => ({
    default: module.CurrencySetupListing,
  })),
);

const currencyRoutes = [
  // {
  //   props: { exact: true, path: '/:mode/general-settings/currency' },
  //   component: <CurrencyListing />,
  // },
  // {
  //   props: { exact: true, path: '/:mode/general-settings/currency-exchange' },
  //   component: <CurrencyListing />,
  // },
  {
    props: { exact: true, path: '/common-settings/currency-setup' },
    component: <CurrencySetupListing />,
  },
];

export default currencyRoutes;
